import type { FC } from 'react';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { Button } from 'src/common/components/button';
import type { ModalSchema } from 'src/common/components/next-modal';
import { useOpenModal } from 'src/common/components/next-modal';
import { Images } from 'src/image';

const TeamWechatQr: FC<ModalSchema.CloseModal> = ({ onCloseModal }) => {
  const { t } = useAppTranslation();
  return (
    <div className="flex flex-col items-center py-10 px-20">
      <div className="text-h3 mb-5">{t('components.select_upgrade_plan.congrats_upgrade')}</div>
      <div className="text-t1 mb-2.5">
        {t('components.select_upgrade_plan.add_manager_for_invoice')}
      </div>
      <img src={Images.teamWechatQr} className="mb-7 w-60 h-60" />
      <Button colorType="active" className="w-full" onClick={() => onCloseModal()}>
        {t('common.components.link_widget.confirm')}
      </Button>
    </div>
  );
};

export const useOpenTeamWechatQr = () => {
  const openModal = useOpenModal();
  return () => {
    openModal.modal({
      modalId: 'paySuccess',
      content: ({ onCloseModal }) => (
        <div>
          <TeamWechatQr onCloseModal={onCloseModal} />
        </div>
      ),
    });
  };
};
